import {useQuery, gql} from "@apollo/client";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";
import {useLogger} from "./useLogger";

const QUERY = gql`
query getArticles($locale: String!, $id: String!, $tags: [String]! ) {
    pageBlogPostCollection(
        locale: $locale,
        order: publishDate_DESC,
        where: {
          sys: {
            id_not: $id
          }
          contentfulMetadata: {
            tags_exists: true
            tags: {  id_contains_some : $tags}
          }
        }
      ) {
         items{
            teaserOfTheArticle
            headerPicture{
              url
            }
            titleOfTheArticle
            publishDate
            bloggerProfile{
              names
              picture{
                url
              }
            }
            category
            contentfulMetadata{
                tags{
                id
                name
                }
            }
            linkedFrom(allowedLocales: ["en-GB"]){
              pageCollection {
                items {
                  slug
                }
              }
            }
        }
      }
}`;

export const useArticlesByTag = (tags, articleId) => {
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {logger} = useLogger();
    const {loading, error, data} = useQuery(QUERY, {variables: {locale: localeUppercase, id: articleId, tags: tags}, errorPolicy: "all", fetchPolicy: "no-cache"});

    const componentData = data?.pageBlogPostCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useArticlesByTag", error?.stack);
    }

    return {
        componentData,
        loading,
        error
    };
};
